import styled from 'styled-components';
import SpeciallyAbledAssistanceIconSvg from '../../assets/hotels/amenities/SpeciallyAbledAssistance.svg';

const SpeciallyAbledAssistanceIcon = styled(
  SpeciallyAbledAssistanceIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default SpeciallyAbledAssistanceIcon;
